

















































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { Handbook, HandbookSubCategory } from "@/api";
import {
  fileRequired,
  maxFileSize,
  requiredSelectWithZero,
} from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";

@Component
export default class HandbookForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() readonly title!: string;
  @Prop() readonly subCategories!: Array<HandbookSubCategory>;
  @Prop() readonly payload!: Handbook;
  @Prop() readonly action!: string;

  loading = false;
  subCategoryId = 0;
  counter = 0;
  url = "";
  documentName = "";
  document: File | null = null;
  fileRules = [fileRequired, (file: File) => maxFileSize(file, 5)];
  selectRules = [requiredSelectWithZero];

  async save() {
    const valid = this.form.validate();
    const payload = this.payload;

    if (valid && this.payload) {
      this.loading = true;
      payload.subCategoryId = this.subCategoryId
        ? this.subCategoryId
        : undefined;
      await this.$store.dispatch(this.action, {
        handbook: payload,
        file: this.document,
      });
      this.loading = true;
      this.close();
    }
  }

  close() {
    this.form.reset();
    this.subCategoryId = 0;
    this.documentName = "";
    this.url = "";
    this.document = null;
    this.$emit("close");
  }

  onChangeFile(file: File) {
    this.counter++;
    if (file) {
      this.documentName = file.name;
      this.url = URL.createObjectURL(file);
      this.document = file;
    }
  }
}
